import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useInstitucion } from '../../context/InstitucionContext';
import MarcaPusah from '../../components/MarcaPusah';

const AdminLogin = () => {
  const history = useHistory();
  const location = useLocation();
  const { login, isAuthenticated } = useAuth();
  // En modo dominio la institución viene del host; en modo plataforma la pantalla es neutra
  // (marca PUSAH) hasta que el usuario entra y se conoce su institución.
  const { institucion, paleta: colors, nombreMarca, seleccionar } = useInstitucion();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Si ya hay sesión, ir directo al panel.
  if (isAuthenticated()) {
    const destino = location.state?.from?.pathname || '/admin';
    history.replace(destino);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const datos = await login(email, password);
      // Usuarios con institución: fijarla en el panel. Un SuperAdmin elige la suya en el panel.
      if (datos.institucion && datos.institucion.slug) {
        seleccionar(datos.institucion.slug);
      }
      const destino = location.state?.from?.pathname || '/admin';
      history.replace(destino);
    } catch (err) {
      setError(err.message || 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
          {/* Cabecera con identidad institucional */}
          <div
            className="px-8 py-8 text-center"
            style={{
              background: `linear-gradient(135deg, ${colors.headerGradientStart}, ${colors.headerGradientMid}, ${colors.headerGradientEnd})`,
            }}
          >
            {/* Logo de la institución junto a la marca de la plataforma (sólo la marca si aún no
                hay institución, como en modo plataforma antes de iniciar sesión) */}
            <div className="flex items-center justify-center gap-4 mb-4">
              {institucion && institucion.logoUrl && (
                <>
                  <img
                    src={`${process.env.PUBLIC_URL}${institucion.logoUrl}`}
                    alt={`Logo ${institucion.nombreCorto}`}
                    className="h-14 drop-shadow"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <span className="h-10 w-px bg-white/30" aria-hidden="true" />
                </>
              )}
              <MarcaPusah variante="blanco" className={institucion ? 'h-7' : 'h-12'} conEnlace={false} />
            </div>
            <h1 className="text-xl font-bold text-white">Panel de Administración</h1>
            <p className="text-white/80 text-sm mt-1">{institucion ? institucion.nombreCorto : nombreMarca}</p>
          </div>

          {/* Formulario */}
          <form onSubmit={handleSubmit} className="px-8 py-8 space-y-5">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-4 py-3">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Correo electrónico</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                style={{ '--tw-ring-color': colors.primary }}
                placeholder="correo@institucion.edu.co"
                autoComplete="username"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Contraseña</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                style={{ '--tw-ring-color': colors.primary }}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 text-white font-semibold rounded-lg transition-all hover:opacity-90 disabled:opacity-60 shadow-md"
              style={{ background: `linear-gradient(135deg, ${colors.accentFrom}, ${colors.accentTo})` }}
            >
              {loading ? 'Ingresando...' : 'Iniciar sesión'}
            </button>
          </form>
        </div>

        <p className="text-center text-gray-400 text-xs mt-6">
          © {new Date().getFullYear()} {institucion ? institucion.nombre : nombreMarca}
          {institucion && <span> · Impulsado por {nombreMarca}</span>}
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
